export class OrderMethod {
    ID: number;
    Name: string;
}

export default OrderMethod;